// import { isDev } from "@/utils/functions/global-constants";

import {
  getBranchIdCookie,
  getCurrencyIdCookie,
  getLangCookie,
  getAgentIdCookie,
  getIPCookie,
} from "@/utils/functions/cookieOperations";
import { cleanObject } from "@/utils/functions/functions";
// import { isDev } from "@/utils/functions/global-constants";

export interface Config {
  baseURL: string;
  headers: {
    "Content-Type": string;
    Accept: string;
    "Accept-Language": string;
    Version: string;
    Platform: string;
    "Branch-Id": string;
    "Agent-Id": string;
    "Company-Id"?: string;
    // Authorization: string;
    referer?: string;
    "Currency-Code"?: string;
  };
}
export const baseURL = process.env.NEXT_PUBLIC_V3_BASE_URL as string;
// "https://ososs.com/api/micro-store/v3";
export const companyId = process.env.NEXT_PUBLIC_V3_COMPANY_ID as string;
// "2416";
// const version = process.env.NEXT_PUBLIC_V3_VERSION;
export const apiConfig = (
  lang?: string,
  host?: string,
  agent_id?: string,
  token?: string,
  currencyCode?: string,
  branch_id?: string,
  ip?: string,
): // language: string, host: string | null = null
Config => {
  let headers: any = {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Accept-Language": lang ?? getLangCookie(),
    "Currency-Code": currencyCode ?? getCurrencyIdCookie(),
    Version: "1.0",
    Platform: "web",
    // "Branch-Id": null,
    // "Accept-Encoding":"gzip, deflate, br",
    "Branch-Id": branch_id ?? getBranchIdCookie() ?? null,
    Authorization: token ? `Bearer ${token}` : null,
    "Agent-Id": agent_id ?? getAgentIdCookie(),
    ip: ip ?? getIPCookie(),
  };
  // if (isDev)
  headers["Company-Id"] = companyId;
  if (host) headers["referer"] = host; //must bereq.headers.host in ssr

  const cleandHeaders = cleanObject(headers) as Config["headers"]; //remove all null or undefined values
  return {
    baseURL: baseURL,
    headers: cleandHeaders,
  };
};
